import { ListOutput } from '@allocab/allocab-commons-shared-types';
import { DocumentItemOutput } from '@allocab/allocab-driver-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { QueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

const fetchDriverDocuments = (driverKey: string) =>
  driverApi.get<void, DocumentItemOutput, 'list'>(`/v1/document/driver/${driverKey}`);

export const useFetchDriverDocuments = (
  driverKey: string,
  options: QueryOptions<typeof queryKeys.user.fetchDriverDocuments, ListOutput<DocumentItemOutput>> = {},
) => useQuery(queryKeys.user.fetchDriverDocuments(driverKey), () => fetchDriverDocuments(driverKey), { ...options });
